<template>
  <div data-testid="file-config-wizard__view">
    <div class="file-config-wizard d-flex justify-center">
      <div class="all-width">
        <v-card :loading="loading" loader-height="2">
          <v-card-text class="d-flex align-center pb-0">
            <v-btn class="shadow-off" text @click.stop="$nova.gotoLink({ path: resolvedBacklink })" icon>
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-btn class="shadow-off" text @click.stop="refreshData()" icon>
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-card-text>
          <v-card-text :class="{ 'pointer-events-off': loading }">
            <v-stepper v-model="e1" class="shadow-off">
              <v-stepper-header class="shadow-off px-0 mx-0">
                <v-stepper-step :complete="e1 > 1" step="1">Step 1</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 2" step="2">Step 2</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="3">Step 3</v-stepper-step>
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content step="1">
                  <StepFileUpload
                    :fileItems="fileItems"
                    :selectFileName="selectFileName"
                    :initialData="stepOneData"
                    @next="onStepOneNext"
                  />
                </v-stepper-content>
                <v-stepper-content step="2">
                  <StepColumnMapping
                    v-if="!isMultiFileType"
                    :selectColums="selectColums"
                    :fileColums="fileColums"
                    @next="onStepTwoNext"
                    @back="onStepTwoBack"
                  />
                  <StepColumnMappingV2
                    v-else
                    :numberOfFileTypes="stepOneData.numberOfFileTypes"
                    :ignoreRow="stepOneData.ignoreRow"
                    :ignoreColums="stepOneData.ignoreColums"
                    :blankheaders="stepOneData.blankheaders"
                    :duplicateColumns="stepOneData.duplicateColumns"
                    @next="onStepTwoNextV2"
                    @back="onStepTwoBack"
                  />
                </v-stepper-content>
                <v-stepper-content step="3">
                  <StepConfigSummary
                    v-if="!isMultiFileType"
                    :nameFile="stepOneData.nameFile"
                    :ignoreRow="stepOneData.ignoreRow"
                    :ignoreColums="stepOneData.ignoreColums"
                    :fileColums="fileColums"
                    :twoDiArray="stepTwoData.twoDiArray"
                    :selectColums="stepTwoData.selectColums"
                    :unMapedColumc="stepTwoData.unMapedColumc"
                    :ignoredColumns="stepTwoData.ignoredColumns"
                    :userMappedColumns="stepTwoData.userMappedColumns"
                    @back="onStepThreeBack"
                    @finish="onFinish"
                  />
                  <StepConfigSummaryV2
                    v-else
                    :stepOneData="stepOneData"
                    :stepTwoDataV2="stepTwoDataV2"
                    :selectFileName="selectFileName"
                    @back="onStepThreeBack"
                    @finish="onFinishV2"
                  />
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-card-text>
        </v-card>
      </div>
    </div>

    <lb-dialog v-model="alreadyConfig" width="400" heading="Information">
      <template v-slot:body>
        <div>
          <div class="d-flex align-center justify-center">
            <v-row>
              <v-col cols="12" class="my-0 py-0">Already configured file</v-col>
            </v-row>
          </div>
        </div>
      </template>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.stop="$nova.gotoLink({ path: resolvedBacklink })">
          <p>Ok</p>
        </v-btn>
      </template>
    </lb-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import StepFileUpload from './FileConfig/StepFileUpload.vue';
import StepColumnMapping from './FileConfig/StepColumnMapping.vue';
import StepConfigSummary from './FileConfig/StepConfigSummary.vue';
import StepColumnMappingV2 from './FileConfigV2/StepColumnMappingV2.vue';
import StepConfigSummaryV2 from './FileConfigV2/StepConfigSummaryV2.vue';
import { buildV2Payload } from './FileConfigV2/utils/helpers';

export default {
  name: 'FileConfigWizard',
  components: {
    StepFileUpload,
    StepColumnMapping,
    StepConfigSummary,
    StepColumnMappingV2,
    StepConfigSummaryV2,
  },
  props: {
    backlink: {
      type: String,
      default: '',
    },
    filelist: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      e1: 1,
      fileColums: [],
      selectFileName: null,
      selectColums: [],
      alreadyConfig: false,
      fileConfigID: null,
      stepOneData: {
        ignoreRow: 0,
        ignoreColums: 0,
        ignoreFooterRows: 0,
        nameFile: '',
        blankheaders: 'left',
        blankRows: true,
        duplicateColumns: false,
        numberOfFileTypes: 1,
        configVersion: 1,
      },
      stepTwoData: {
        twoDiArray: [],
        mapedColumns: [],
        unMapedColumc: [],
        ignoredColumns: [],
        createColumns: false,
        userMappedColumns: [],
        selectColums: [],
      },
      stepTwoDataV2: {
        fileTypes: [],
        columnmap: [],
        primaryKeys: [],
        selectedBaseFileTypeKey: '',
        fileTypeEntries: [],
      },
    };
  },
  computed: {
    ...mapGetters('bot', ['fileMasters', 'fileMasterConfigLoading']),
    isMultiFileType() {
      return (this.stepOneData.numberOfFileTypes || 1) > 1 || this.stepOneData.configVersion === 2;
    },
    loading() {
      return this.fileMasterConfigLoading;
    },
    fileItems() {
      if (this.filelist && this.filelist.length > 0) {
        return this.fileMasters.filter((x) => this.filelist.includes(x._id));
      }
      return this.fileMasters;
    },
    /** True when editing an existing config (configID route param present) */
    isEditMode() {
      return !!this.fileConfigID;
    },
    /** Resolve back link: prop > auto-detect from route context */
    resolvedBacklink() {
      if (this.backlink) return this.backlink;
      // If opened from file master route, go back to file master list
      if (this.$route.params.conid) return '/bot/filemaster';
      // Otherwise go back to file list
      return '/bot/filelist';
    },
  },
  created() {
    this.fileConfigID = this.$route.params.configID || null;
    this.refreshData();
  },
  activated() {
    this.fileConfigID = this.$route.params.configID || null;
    this.refreshData();
  },
  methods: {
    ...mapActions('bot', ['fetchFileMasters', 'fetchFileConfig', 'addFileConfig', 'addFileConfigV2', 'editFileConfig', 'editFileConfigV2']),

    async refreshData() {
      try {
        await this.fetchFileMasters();

        // If opened from file master route (conid), pre-select the file master
        const conid = this.$route.params.conid;
        if (conid) {
          const getfile = this.fileMasters.filter((x) => x._id === conid);
          if (getfile.length > 0) {
            this.fileColums = getfile[0].columns;
            this.selectFileName = conid;
          }
        }

        // If editing an existing config, load its saved values
        if (this.fileConfigID) {
          await this.loadExistingConfig();
        }
      } catch (err) {
        console.error('[FileConfigWizard]: refreshData error', err);
      }
    },

    async loadExistingConfig() {
      try {
        const result = await this.fetchFileConfig(this.fileConfigID);
        if (result.status === 'success') {
          const config = result.data[0] || {};
          const isV2 = config.version === 'v2';

          this.selectFileName = config.file;

          if (isV2) {
            const fileTypes = config.fileTypes || [];
            this.stepOneData = {
              ignoreRow: 0,
              ignoreColums: 0,
              ignoreFooterRows: 0,
              nameFile: '',
              blankheaders: 'left',
              blankRows: true,
              duplicateColumns: false,
              numberOfFileTypes: fileTypes.length || 1,
              configVersion: 2,
            };
            this.stepTwoDataV2 = {
              fileTypes: fileTypes,
              columnmap: config.columnmap || [],
              primaryKeys: config.primaryKeys || [],
              selectedBaseFileTypeKey: fileTypes.length > 0 ? fileTypes[0].key : '',
              fileTypeEntries: fileTypes.map((ft) => ({
                key: ft.key,
                name: ft.name,
                fileName: '',
                headers: [],
                status: 'pending',
                rawData: [],
                ignorerows: ft.ignorerows || 0,
                ignorecolumns: ft.ignorecolumns || 0,
                ignorefooterrows: ft.ignorefooterrows || 0,
                blankcolumnheaders: ft.blankcolumnheaders || 'left',
                removeblankrows: ft.removeblankrows !== false,
                keepduplicatecolumns: !!ft.keepduplicatecolumns,
              })),
            };
          } else {
            this.stepOneData = {
              ignoreRow: config.ignorerows || 0,
              ignoreColums: config.ignorecolumns || 0,
              ignoreFooterRows: config.ignorefooterrows || 0,
              nameFile: '',
              blankheaders: config.blankcolumnheaders || 'left',
              blankRows: config.removeblankrows !== false,
              duplicateColumns: !!config.keepduplicatecolumns,
              numberOfFileTypes: 1,
              configVersion: 1,
            };
          }
        } else {
          throw new Error(result.message);
        }
      } catch (err) {
        this.$store.commit('sbError', err.message || err || 'Failed to load existing config');
        console.error('[FileConfigWizard]: loadExistingConfig error', err);
      }
    },

    onStepOneNext(data) {
      this.selectColums = data.selectColums;
      this.stepOneData = {
        ignoreRow: data.ignoreRow,
        ignoreColums: data.ignoreColums,
        ignoreFooterRows: data.ignoreFooterRows,
        nameFile: data.nameFile,
        blankheaders: data.blankheaders,
        blankRows: data.blankRows,
        duplicateColumns: data.duplicateColumns,
        numberOfFileTypes: data.numberOfFileTypes,
        configVersion: data.configVersion,
      };
      this.e1 = 2;
    },

    onStepTwoNext(data) {
      this.stepTwoData = {
        twoDiArray: data.twoDiArray,
        mapedColumns: data.mapedColumns,
        unMapedColumc: data.unMapedColumc,
        ignoredColumns: data.ignoredColumns,
        createColumns: data.createColumns,
        userMappedColumns: data.userMappedColumns,
        selectColums: data.selectColums,
      };
      this.e1 = 3;
    },

    onStepTwoNextV2(data) {
      this.stepTwoDataV2 = {
        fileTypes: data.fileTypes,
        columnmap: data.columnmap,
        primaryKeys: data.primaryKeys,
        selectedBaseFileTypeKey: data.selectedBaseFileTypeKey,
        fileTypeEntries: data.fileTypeEntries,
      };
      this.e1 = 3;
    },

    onStepTwoBack() {
      this.e1 = 1;
    },

    onStepThreeBack() {
      if (!this.isMultiFileType) {
        this.stepTwoData.unMapedColumc = [];
        this.stepTwoData.ignoredColumns = [];
      }
      this.e1 = 2;
    },

    async onFinish() {
      const payload = {
        file: this.selectFileName,
        ignorerows: this.stepOneData.ignoreRow,
        ignorecolumns: this.stepOneData.ignoreColums,
        columnmap: this.stepTwoData.mapedColumns,
        usercolumnmap: this.stepTwoData.userMappedColumns,
        ignoredcolumns: this.stepTwoData.ignoredColumns,
        unusedcolumns: this.stepTwoData.unMapedColumc,
        createcolumns: this.stepTwoData.createColumns,
        blankcolumnheaders: this.stepOneData.blankheaders,
        removeblankrows: this.stepOneData.blankRows,
        keepduplicatecolumns: this.stepOneData.duplicateColumns,
      };
      try {
        let result;
        if (this.isEditMode) {
          result = await this.editFileConfig({ id: this.fileConfigID, payload });
        } else {
          result = await this.addFileConfig(payload);
        }
        if (result.status === 'success') {
          this.selectFileName = '';
          this.e1 = 1;
          this.$nova.gotoLink({ path: this.resolvedBacklink });
        } else if (result.data && result.data.length > 0) {
          if (result.data[0].index0.file[0] === 'already exist') {
            this.alreadyConfig = true;
          }
        } else {
          throw new Error(result.message || 'Error saving file config');
        }
      } catch (err) {
        this.$store.commit('sbError', err.message || err || 'Unknown error!');
        console.error('[FileConfigWizard]: onFinish error', err);
      }
    },

    async onFinishV2() {
      const payload = buildV2Payload(this.stepOneData, this.stepTwoDataV2, this.selectFileName);
      try {
        let result;
        if (this.isEditMode) {
          result = await this.editFileConfigV2({ id: this.fileConfigID, payload });
        } else {
          result = await this.addFileConfigV2(payload);
        }
        if (result.status === 'success') {
          this.selectFileName = '';
          this.e1 = 1;
          this.$nova.gotoLink({ path: this.resolvedBacklink });
        } else if (result.data && result.data.length > 0) {
          if (result.data[0].index0.file[0] === 'already exist') {
            this.alreadyConfig = true;
          }
        } else {
          throw new Error(result.message || 'Error saving v2 file config');
        }
      } catch (err) {
        this.$store.commit('sbError', err.message || err || 'Unknown error!');
        console.error('[FileConfigWizard]: onFinishV2 error', err);
      }
    },
  },
  beforeDestroy() {
    this.selectColums = [];
    this.stepOneData = {};
    this.stepTwoData = {};
    this.stepTwoDataV2 = {};
  },
};
</script>

<style lang="scss" scoped>
.file-config-wizard {
  height: 95%;
}

.pointer-events-off {
  pointer-events: none;
  opacity: 0.6;
}
</style>
